import React, { useRef, useState, useEffect } from 'react';
import { fetchBuyingPartyMovies } from '@Services/api';
import VideoPlayer from './VideoPlayer';
import { useQuery } from 'react-query';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { gaEvent } from '@Lib/ga';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import styles from './index.module.less';
import './video.css';

SwiperCore.use([Navigation, Pagination]);



const Video: React.FC<{ title?: string; type?: string; fetchFunction?: any }> = ({ title }) => {

  return null

  const videos = useRef<any[]>([]);
  const [mySwiper, setMySwiper] = useState<any>({});
  const videoLeftRef = useRef(null);
  const videoRightRef = useRef(null);
  const contentRef = useRef<any>(null);
  const [contentVisible, setVisible] = useState(false);

  const { data } = useQuery(
    `fetchBuyingPartyMovies-article`,
    async () => {
      const res = await fetchBuyingPartyMovies({ type: 'article' });
      if (res?.status === 12000) {
        return res.data.list;
      }
    },
    { initialData: [] },
  );

  const init = (mySwiper: any) => {
    mySwiper.on('realIndexChange', (e) => {
      const activeIndex = e.activeIndex;
      const otherVideo = videos.current.filter((_, inx) => inx !== activeIndex);

      setTimeout(() => {
        otherVideo.forEach((video) => video?.pause());
        videos.current[activeIndex]?.play();
      }, 500);
    });
  };

  useEffect(() => {
    const observe = new IntersectionObserver(
      (entrie) => {
        if (entrie[0].isIntersecting) {
          // setVisible(true);
        }
      },
      { threshold: 0.2 },
    );
    contentRef.current && observe.observe(contentRef.current);
  }, []);

  useEffect(() => {
    gaEvent('搶購趴活動（曝光）', '活動音影', '立即參與活動');
    if (data?.length !== 0 && videos?.current?.length === data?.length) {
      console.log(videos);
    }
  }, [videos, data]);

  return (
    <section className={styles['Video']} ref={contentRef}>
      {contentVisible && (
        <>
          <i className={styles['left-video-icon']} ref={videoLeftRef} />
          <i className={styles['right-video-icon']} ref={videoRightRef} />
          <div className={styles['video-list']}>
            <Swiper
              onInit={(e) => {
                setMySwiper(e);
                init(e);
              }}
              pagination={{
                clickable: true,
                clickableClass: 'my-pagination-clickable',
              }}
              navigation={{
                nextEl: videoRightRef.current,
                prevEl: videoLeftRef.current,
              }}
              className="mySwiper"
            >
              {Array.isArray(data) &&
                data.map((item, index) => (
                  <SwiperSlide style={{ height: '250px' }}>
                    <div>
                      <VideoPlayer
                        id={`buyingPartyMovies-article-${index}`}
                        src={item.link}
                        poster={item.thumb}
                        width={'280px'}
                        height={'220px'}
                        autoplay={!index}
                        onPlaying={() => {
                          title && gaEvent('搶購趴活動', '活動音影', '活動影片');
                        }}
                        onEnded={() => {
                          mySwiper?.slideNext();
                        }}
                        onReady={(player) => {
                          videos.current[index] = player;
                        }}
                      />
                    </div>
                  </SwiperSlide>
                ))}
            </Swiper>
          </div>
        </>
      )}
    </section>
  );
};
export default Video;
